"use client";

export default function ContactMap() {
  return (
    <div className="w-full h-full">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3143.338043375464!2d12.504570011358139!3d38.015897998116834!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x13196112c3873579%3A0x4ba010c0413c9f05!2sBeehive%20Valore%20Sud%20-%20Coworking%20Trapani!5e0!3m2!1sit!2sit!4v1752085219507!5m2!1sit!2sit"
        style={{ border: 0 }}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        className="w-full h-full rounded-lg"
      />
    </div>
  );
}
